<template>
  <div id="accountRecord">
    <el-table
      class="newslist"
      :data="ListData"
      empty-text="目前無任何序號"
    >
      <el-table-column
        type="index"
        width="50"
      />
      <el-table-column
        prop="Sn"
        label="開通序號"
      />
      <el-table-column
        prop="Permission"
        label="序號權限"
      >
        <template slot-scope="scope">
          {{ filterPermission(scope.row.Permission) }}
        </template>
      </el-table-column>
      <el-table-column
        prop="CreateAt"
        label="建立時間"
      >
        <template slot-scope="scope">
          {{ scope.row.CreateAt.split(":")[0] }}:{{ scope.row.CreateAt.split(":")[1] }}
        </template>
      </el-table-column>
      <el-table-column
        prop="Status"
        label="使用狀況"
      >
        <template slot-scope="scope">
          <span :class="`status${scope.row.Status}`">
            {{ filterStatus(scope.row.Status) }}
          </span>
        </template>
      </el-table-column>
      <el-table-column
        prop="date"
        label="操作"
        width="120"
      >
        <template
          v-if="scope.row.Status === 1"
          slot-scope="scope"
        >
          <el-button
            size="mini"
            plain
            @click="delOpenCode(scope.row, scope.$index)"
          >
            註銷序號
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <TableLoading :is-loading="loading" />
    <AuthDialog ref="authDialog" />
  </div>
</template>
<script>
import TableLoading from '@/components/TableLoading'
import AuthDialog from './components/AuthDialog.vue'
export default {
  components: {
    AuthDialog,
    TableLoading
  },
  data () {
    return {
      activeName: 'accountRecord',
      scrollEnd: false,
      loading: false,
      offset: 0,
      maxCount: 10,
      ListData: []
    }
  },
  mounted () {
    if (!JSON.parse(localStorage.getItem('loginUserInfo')).IsAuthorizationAccount && !JSON.parse(localStorage.getItem('loginUserInfo')).IsFromEip) {
      this.$alert('沒有訪問權限', '警告', {
        confirmButtonText: '確定',
        type: 'warning',
        showClose: false,
        roundButton: true,
        closeOnClickModal: false
      }).then(() => {
        this.$router.back()
      })
      return false
    }
    window.addEventListener('scroll', this.autoShow, true)
    this.getOpenCodes()
  },
  beforeDestroy () {
    window.removeEventListener('scroll', this.autoShow, true)
  },
  methods: {
    // 下拉到底自動載入
    autoShow () {
      // 視窗滾動條高度
      const ScrollTop = document.documentElement.scrollTop
      // console.log(`視窗滾動條高度:${ScrollTop}`)
      // 視窗可視範圍高度
      const ClientHeight = document.documentElement.clientHeight
      // console.log(`視窗可視範圍高度:${ClientHeight}`)
      // 內容實際高度
      const ScrollHeight = document.documentElement.scrollHeight
      // console.log(`內容實際高度:${ScrollHeight}`)

      // console.log(ScrollTop+ClientHeight +" : "+ ScrollHeight)
      // console.log(`${ScrollTop+ClientHeight}:${ScrollHeight}`)
      // eslint-disable-next-line eqeqeq
      if ((ScrollTop + ClientHeight >= ScrollHeight - 20) && !this.loading && this.$router.currentRoute.name == 'accountRecord') {
        if (!this.scrollEnd) {
          this.offset += 10
          this.getOpenCodes()
        }
      }
    },
    delOpenCode (code, index) {
      if (!JSON.parse(localStorage.getItem('loginUserInfo')).IsAuthorizationAccount) {
        this.$alert('登入過期或驗證失敗，請重新登入', '警告', {
          confirmButtonText: '確定',
          type: 'warning',
          showClose: false,
          roundButton: true,
          closeOnClickModal: false
        }).then(() => {
          this.$logoutCommunity()
        })
      } else {
        const url = `${process.env.VUE_APP_CORE_URL}/api/AuthorizationSn/${code.Id}`
        axios(url, {
          method: 'DELETE',
          headers: {
            kingnetauth: `Cookies ${this.$getCookie('comLoginToken').replace('token=', '')}`
          }
        }).then(res => {
          this.ListData[index].Status = 0
          this.$alert(`${code.Sn}註銷成功`, '', {
            confirmButtonText: '確定',
            type: 'success',
            callback: action => {}
          })
        }).catch(err => {
          this.$alert('登入過期或驗證失敗，請重新登入', '警告', {
            confirmButtonText: '確定',
            type: 'warning',
            showClose: false,
            roundButton: true,
            closeOnClickModal: false
          }).then(() => {
            this.$logoutCommunity()
          })
        })
      }
    },
    getOpenCodes () {
      const ScrollHeight = document.getElementById('accountRecord').scrollHeight
      const url = `${process.env.VUE_APP_CORE_URL}/api/AuthorizationSn`
      this.loading = true
      axios(url, {
        method: 'GET',
        headers: {
          kingnetauth: `Cookies ${this.$getCookie('comLoginToken').replace('token=', '')}`
        },
        params: {
          Offset: this.offset,
          MaxCount: this.maxCount
        }
      }).then(res => {
        this.loading = false
        if (res.data.Data.Sns.length !== 0) {
          this.ListData = this.ListData.concat(res.data.Data.Sns)
          if (this.ListData.length > 10) {
            window.scrollTo(0, ScrollHeight - 800)
          }
          if (res.data.Data.Sns.length < 10) {
            this.scrollEnd = true
          }
        } else {
          this.scrollEnd = true
        }
      }).catch(err => {
        console.log(err)
        if (err.response.status === 401 || !JSON.parse(localStorage.getItem('loginUserInfo')).IsAuthorizationAccount) {
          this.$alert('登入過期或驗證失敗，請重新登入', '警告', {
            confirmButtonText: '確定',
            type: 'warning',
            showClose: false,
            roundButton: true,
            closeOnClickModal: false
          }).then(() => {
            this.$logoutCommunity()
          })
        }
      })
    },
    filterPermission (permission) {
      switch (permission) {
        case 1:
          return '最高管理者'
        case 2:
          return '一般管理者'
      }
    },
    filterStatus (status) {
      switch (status) {
        case 0:
          return '已失效'
        case 1:
          return '未使用'
        case 2:
          return '已使用'
      }
    }
  }
}
</script>

<style lang="sass" scoped>
#accountRecord
  text-align: center
  padding: 20px 0 10px
  height: 100%
  .newslist
    font-size: 15px
    .cell
      +NewsStatusTag
      .status0
        color: #C44536
      .status1
        color: #7F7F7F
      .status2
        color: $mainColor
    ::v-deep .el-table
      +basicTable

</style>
